import { environment } from '../../../src/environments/environment';


export class AppConstants {
  public static WEBSITE_URL = environment.webUrl; 

  private static API_BASE_URL = environment.apiUrl; 
  private static OAUTH2_URL = AppConstants.API_BASE_URL + "oauth2/authorize/";
  private static REDIRECT_URL = "redirect_uri=" + environment.redirectUrl;
  private static FORCE_REDIRECT_URL = "redirect_uri=" + environment.forceRedirectUrl;

  public static API_URL = AppConstants.API_BASE_URL; 
  public static AUTH_API = AppConstants.API_URL + "auth/";
  // public static GOOGLE_AUTH_URL = AppConstants.OAUTH2_URL + "google?forceLogin=false&" + AppConstants.REDIRECT_URL + "&method=google";
  public static GOOGLE_AUTH_URL_FORCE = AppConstants.OAUTH2_URL + "google?forceLogin=true&" + AppConstants.FORCE_REDIRECT_URL + "&method=google";
  public static GOOGLE_AUTH_URL = AppConstants.GOOGLE_AUTH_URL_FORCE;// AppConstants.OAUTH2_URL + "google?forceLogin=false&" + AppConstants.REDIRECT_URL + "&method=google";

  public static MICROSOFT_AUTH_URL = AppConstants.OAUTH2_URL + "microsoft?forceLogin=false&" + AppConstants.REDIRECT_URL + "&method=microsoft";
  public static MICROSOFT_AUTH_URL_FORCE = AppConstants.OAUTH2_URL + "microsoft?forceLogin=false&" + AppConstants.FORCE_REDIRECT_URL + "&method=microsoft";


  public static LINKEDIN_AUTH_URL = AppConstants.OAUTH2_URL + "linkedin?" + AppConstants.REDIRECT_URL + "&method=linkedin";
  public static LINKEDIN_AUTH_URL_FORCE = AppConstants.OAUTH2_URL + "linkedin?forceLogin=true&" + AppConstants.FORCE_REDIRECT_URL + "&method=linkedin";
  
  public static SOCIAL_PROVIDER_GOOGLE = "google";
  public static SOCIAL_PROVIDER_MICROSOFT = "microsoft";
  public static SOCIAL_PROVIDER_LINKEDIN = "linkedin";

  // public static USER_KEY = 'user';

  // public static CURRENT_USER_KEY = 'current_user';

  public static PROMOTOER_CODE = 'promoter_code';
  public static USER = 'user';
  public static REDIRECT_SNAPSHOT_URL = 'redirect_url';
  // Plain (non-secret) marker — survives logout's localStorage.clear() (see LogoutService) so
  // the NEXT login can detect a different user on this device and wipe the offline write queue.
  public static LAST_DEVICE_USER_EMAIL = 'tms_last_device_user_email';
  // Sibling of the above, same survives-logout rationale. Needed because email ALONE cannot
  // detect a multi-company switch (same email, different tenant) — which left a previous
  // tenant's rows in the offline cache. Absence of this key on an otherwise-populated cache
  // means "written before tenant tracking existed", i.e. provenance unknown.
  public static LAST_DEVICE_TENANT_ID = 'tms_last_device_tenant_id';

  // iOS only — a hard `window.location.href` to a brand-new URL can bounce the app out to
  // Safari instead of staying in the WKWebView (confirmed 2026-09-03). When login.component.ts
  // needs a genuine full-page reload (cross-account switch on the same device), it reloads the
  // CURRENT page in place instead and stashes the real target here; ngOnInit picks it up and
  // routes there once Angular re-bootstraps. See navigateAfterLogin().
  public static PENDING_IOS_RELOAD_REDIRECT = 'tms_pending_ios_reload_redirect';

  public static DASHBOARD = '/';

  public static FONT_SIZE ='font-size';

  public static THEME ='theme';

  public static CONTAINER ='container';

  public static VIEW ='view';

  public static PUBLIC_URL_HOPPUS = '/public/view/measurement/';  
 
  public static PUBLIC_URL_VOLUMETRIC =  '/public/view/sawn-timber/';

  public static MEASUREMENT =  'measurement';

  public static PUBLIC_URL_BL =   '/public/view/bill-of-ladings/' ;

  // public static PUBLIC_URL_CONTAINER = '/public/view/measurement/'
  public static PUBLIC_URL_FORUMLA_1_CONTAINER = '/public/view/measurement/';
  public static PUBLIC_SHORT_URL_FORUMLA_1_CONTAINER = '/public/view/measurement/';

  public static PUBLIC_URL_FORUMLA_2_CONTAINER = '/public/view/sawn-timber/';

  public static HOPPUS_NAME ='Hoppus';

  public static RECTANGLE_PRISM_NAME ='Volumetric';

  public static SHOW_MENU_HOT_KEY = 'm'

  public static MAX_NUMBER_OF_IMAGES_UPLOAD = 5;

  public static MAX_IMAGE_SIZE_IN_MB = 5;

  public static BL_VIEW ='bl_view';

  public static SHIPMENT_COUNT = `${AppConstants.API_URL}openforall/api/v1/bills-of-lading/count`

  public static CONTAINERS_COUNTS =`${AppConstants.API_URL}openforall/api/v1/containers/count` 

  public static SHIPMENT_ARRIVING_COUNT = `${AppConstants.API_URL}openforall/api/v1/bills-of-lading/count-eta`

  public static SHIPMENT_DEPARTING_COUNT = `${AppConstants.API_URL}openforall/api/v1/bills-of-lading/count-etd`

  public static MONTHLY_SHIPMENT = `${AppConstants.API_URL}openforall/api/v1/bills-of-lading/monthly-counts`

  public static MONTHLY_CONTAINERS = `${AppConstants.API_URL}openforall/api/v1/containers/monthly-counts`

  public static COUNT_COUNTRY_OF_ORIGINS = `${AppConstants.API_URL}openforall/api/v1/containers/counts-by-country-of-origin`

  public static MONTHLY_PRODUCTS = `${AppConstants.API_URL}openforall/api/v1/containers/counts-by-product`

  public static LUMBER_LINQ_WEBSITE = `https://www.lumberlinq.com`;

  // Android is live on Google Play (confirmed 2026-08-24) — its CTA constant below now points
  // to the real store URL. iOS is still not published (see /get-the-app). Once iOS goes live,
  // flip its CTA constant too — the banner and coming-soon page both read only these constants,
  // so nothing else needs to change. Android and iOS are independent
  // so they can launch on different dates.
  public static MOBILE_APP_BANNER_ENABLED = true;
  public static ANDROID_PACKAGE_ID = 'com.lumberlinq.app'; // matches capacitor.config.ts appId
  public static IOS_BUNDLE_ID = 'com.lumberlinq.app'; // matches capacitor.config.ts appId
  public static ANDROID_APP_CTA_URL = `https://play.google.com/store/apps/details?id=${AppConstants.ANDROID_PACKAGE_ID}`;
  public static IOS_APP_CTA_URL = '/get-the-app';
  // public static IOS_APP_CTA_URL = `https://apps.apple.com/app/idXXXXXXXXX`; // fill in real App Store id once published

  public static PUBLIC_SHARE_URL = environment.shareUrl;

  // Canonical public origin of the web app (no trailing slash) — always use this to build
  // share / QR / deep links, never window.location.origin (which is https://localhost or
  // capacitor://localhost inside the native WebView). Falls back to the origin of webUrl so it
  // is still correct on STAGE, whose environment.stage.ts is gitignored and may lack webAppUrl.
  public static WEB_APP_URL: string = (() => {
    const e = environment as { webAppUrl?: string; webUrl?: string };
    if (e.webAppUrl) return e.webAppUrl.replace(/\/+$/, '');
    try { return new URL(e.webUrl ?? '').origin; } catch { return ''; }
  })();

  // Environment-scoped, and it MUST match the backend's CookieService.scopedName().
  //
  // app./api., stage./stage-api. and dev./dev-api. all share the lumberlinq.com parent domain,
  // and the auth cookies have to be written on that parent for the page and the API to both see
  // them. A cookie is keyed by (name, domain, path), so identical names meant PROD, STAGE and DEV
  // were overwriting one another's cookie: logging into stage logged you out of app, and back.
  // PROD stays unsuffixed (''), so prod is unchanged and needs no redeploy; only non-prod moves.
  //
  // Read defensively: environment.dev.ts / environment.stage.ts / environment.vps.ts are
  // gitignored and live only on the server, so a missing field must not break the build — it
  // just falls back to the prod-style bare name.
  public static ENCRYPTION_KEY_COOKIE_NAME =
    'x_client_id' + ((environment as any).cookieSuffix ?? '');

  public static USER_PROFILE_KEY = 'app-metadata-key';

  // Last volume unit (CBM/CFT) the user clicked to view stock figures in — Stock Availability
  // panel remembers this across sessions so it doesn't reset to CBM every time the TU form loads.
  public static STOCK_VOLUME_UNIT = 'tms-stock-volume-unit';
}
